import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueScrollTo from 'vue-scrollto'
import './plugins/element.js'
import i18n from './i18n/i18n'
// 导入全局样式
import './assets/css/global.css'
import VueCookies from 'vue-cookies'
// import axios from 'axios'
import Lcommon from './utils/common.js'
Vue.use(VueCookies)
Vue.use(VueScrollTo)
Vue.prototype.$lcommon = Lcommon
Vue.config.productionTip = false
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
